import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentsComponent } from './comments/comments.component';
import { FileAttachmentComponent } from './file-attachment/file-attachment.component';
import { RecordRightSidebarComponent } from './record-right-sidebar/record-right-sidebar.component';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteAllModule, DropDownListAllModule, DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { DatePickerAllModule, DateTimePickerAllModule } from '@syncfusion/ej2-angular-calendars';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TCPExpiryComponent } from './tcpexpiry/tcpexpiry.component';
import { GetDateTimeComponent } from './get-date-time/get-date-time.component';
import { AccordionComponent } from './accordion/accordion.component';
import { MteInputComponent } from './mte-input/mte-input.component';
import { MteIndexComponent } from './mte-index/mte-index.component';
import { MessageInputComponent } from './message-input/message-input.component';
import { ToastAllModule } from '@syncfusion/ej2-angular-notifications';
import { DialogAllModule } from '@syncfusion/ej2-angular-popups';
import {
  PdfViewerAllModule,
  BookmarkViewService,
  MagnificationService,
  NavigationService,
  PrintService,
  TextSearchService,
  TextSelectionService,
  ThumbnailViewService,
  ToolbarService,
  LinkAnnotationService
} from '@syncfusion/ej2-angular-pdfviewer';
import { SharedwithComponent } from './sharedwith/sharedwith.component';
import { ChatUIModule } from '@syncfusion/ej2-angular-interactive-chat';
import { TimelineModule } from '@syncfusion/ej2-angular-layouts';
import { TimelineComponent } from './timeline/timeline.component';
import { PdfPreviewComponent } from './pdf-preview/pdf-preview.component';
import { ImagePreviewComponent } from './image-preview/image-preview.component';


@NgModule({
  declarations: [
    CommentsComponent,
    FileAttachmentComponent,
    RecordRightSidebarComponent,
    TCPExpiryComponent,
    GetDateTimeComponent,
    AccordionComponent,
    MteInputComponent,
    MteIndexComponent,
    MessageInputComponent,
    SharedwithComponent,
    TimelineComponent,
    PdfPreviewComponent,
    ImagePreviewComponent
  ],
  imports: [
    CommonModule,
    GridAllModule,
    ToastAllModule,
    TabsModule,
    ReactiveFormsModule,
    AutoCompleteAllModule,
    DropDownListAllModule, 
    DropDownListModule,
    DateTimePickerAllModule,
    DatePickerAllModule,
    ProgressbarModule,
    DialogAllModule,
    PdfViewerAllModule,
    ChatUIModule,
    TimelineModule
  ],
  providers: [
    ToolbarService,
    MagnificationService,
    NavigationService,
    LinkAnnotationService,
    BookmarkViewService,
    ThumbnailViewService,
    PrintService,
    TextSelectionService,
    TextSearchService
  ],
  exports: [
    FileAttachmentComponent,
    CommentsComponent,
    RecordRightSidebarComponent,
    TCPExpiryComponent,
    GetDateTimeComponent,
    AccordionComponent,
    MteInputComponent,
    MteIndexComponent,
    MessageInputComponent,
    TimelineComponent,
    PdfPreviewComponent,
    ImagePreviewComponent
  ]
})
export class UtilityModule { }
